import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { useIntl } from 'react-intl';

import useElementSize from '../../hooks/useElementSize';
import * as AppPropTypes from '../../lib/PropTypes';

import { useUrlFromHandle, useUrlGenerator } from '../../contexts/RoutesContext';
import { useWindowSize } from '../../contexts/SiteContext';
import SectionPreviewCard from '../cards/SectionPreview';
import SectionHeader from '../partials/SectionHeader';

import styles from '../../../styles/blocks/sections.module.scss';

const propTypes = {
    title: PropTypes.node,
    sections: AppPropTypes.listItems,
    edition: AppPropTypes.edition,
    isGrid: PropTypes.bool,
    isContainer: PropTypes.bool,
    isDark: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    title: null,
    sections: null,
    edition: null,
    isGrid: true,
    isContainer: false,
    isDark: false,
    className: null,
};

const SectionsBlock = ({
    title: listTitle,
    sections,
    edition,
    isGrid,
    isContainer,
    isDark,
    className,
}) => {
    const intl = useIntl();
    const ref = useRef(null);
    const { width: windowWidth } = useWindowSize();
    const { width: gridWidth = null } = useElementSize(ref.current);
    const finalWidth = gridWidth || windowWidth || null;
    // console.log('finalWidth', finalWidth);

    let columns = 1;
    if (finalWidth !== null) {
        if (finalWidth < 600) {
            columns = 1;
        } else if (finalWidth > 600 && finalWidth < 980) {
            columns = 2;
        } else if (finalWidth > 980 && finalWidth < 1600) {
            columns = 3;
        } else if (finalWidth > 1600) {
            columns = 4;
        }
    }

    const handle = useUrlFromHandle();
    const route = useUrlGenerator();
    const { handle: editionHandle = null } = edition || {};
    const hasTitle = listTitle !== null;

    return (
        <div
            ref={ref}
            className={classNames([
                styles.container,
                {
                    [styles.isContainer]: isContainer,
                    [styles.grid]: isGrid,
                    [styles.hasTitle]: hasTitle !== null,
                    [className]: className !== null,
                },
            ])}
        >
            {hasTitle ? (
                <SectionHeader
                    className={classNames([styles.header, { [styles.isDark]: isDark }])}
                    title={listTitle}
                    url={
                        editionHandle !== null
                            ? route('index_edition', { index: 'films', edition: editionHandle })
                            : handle('films')
                    }
                    buttonLabel={intl.formatMessage({
                        defaultMessage: 'See all sections',
                        description: 'Button label',
                    })}
                    isDark={isDark}
                />
            ) : null}

            <div className={classNames([styles.inner, styles[`columns${columns}`]])}>
                {(sections || []).map((section) => {
                    const { handle: sectionHandle = null } = section || null;
                    return <SectionPreviewCard key={`section-${sectionHandle}`} item={section} />;
                })}
            </div>
        </div>
    );
};
SectionsBlock.propTypes = propTypes;
SectionsBlock.defaultProps = defaultProps;

export default SectionsBlock;
